import { useState, useEffect } from 'react';
import { Table, Select, Button, Modal, Form, Input, Tag } from 'antd';
import { getData } from '../api/api';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

const StaticQrs = () => {
    const [data, setData] = useState([]);
    const [partners, setPartners] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60,
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'ID', dataIndex: 'id', key: 'id', width: 150 },
        { title: 'Terminal turi', dataIndex: 'terminalType', key: 'terminalType', width: 150 },
        { title: 'Terminal nomi', dataIndex: 'terminalName', key: 'terminalName', width: 150 },
        { title: 'Merchant nomi', dataIndex: 'merchantName', key: 'merchantName', width: 150 },
        { title: 'Partner nomi', dataIndex: 'partnerName', key: 'partnerName', width: 150 },
        {
            title: 'Min summasi',
            dataIndex: 'minAmount',
            key: 'minAmount',
            width: 250,
            render: (minAmount) => <p>{(minAmount / 100).toLocaleString()}  so'm</p>,
        },

        {
            title: 'Max summasi',
            dataIndex: 'maxAmount',
            key: 'maxAmount',
            width: 250,
            render: (maxAmount) => <p>{(maxAmount / 100).toLocaleString()}  so'm</p>,
        },
        { title: 'Redirect URL', dataIndex: 'redirectUrl', key: 'redirectUrl', width: 200 },
        { title: 'Link', dataIndex: 'link', key: 'link', width: 200 },
        { title: 'Yaratilgan vaqti', dataIndex: 'createdAt', key: 'createdAt', width: 180 },
        { title: "O'zgartirilgan vaqti", dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
        {
            title: 'Holati',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? (
                    <Tag color="green">Faol</Tag>
                ) : (
                    <Tag color="red">Nofaol</Tag>
                ),
        },
        // {
        //     title: 'Amallar',
        //     key: 'actions',
        //     width: 200,
        //     render: (_, record) => (
        //         <>
        //             <Button size="small" onClick={() => handleUpdate(record)}>
        //                 O'zgartirish
        //             </Button>
        //             <Button size="small" danger onClick={() => handleDelete(record.id)} style={{ marginLeft: 8 }}>
        //                 O'chirish
        //             </Button>
        //         </>
        //     ),
        // },
    ];

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData('/admin/static-qr-list-by-filter', {
                page: pagination.current - 1,
                size: pagination.pageSize,
                status: -1,
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const getPartners = async () => {
        try {
            const response = await getData('/admin/partner-list-by-filter', {
                page: 0,
                size: 100000, // Keyinchalik yangi API chiqadi
                status: -1,
            });
            setPartners(response.data?.data?.content || []);
        } catch (error) {
            console.error(error);
        }
    };

    const getMerchants = async () => {
        const pId = filters.partnerId;
        if (pId) {
            try {
                const response = await getData('/admin/merchants-list-by-filter', {
                    page: 0,
                    size: 1000000, // Keyinchalik yangi API chiqadi
                    status: -1,
                    partnerId: pId,
                });
                setMerchants(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setMerchants([]); // PartnerId yo'q bo'lsa, merchantsni tozalash
        }
    };


    const getTerminals = async () => {
        const partnerId = filters.partnerId;
        const merchantId = filters.merchantId;
        if (partnerId && merchantId) {
            try {
                const response = await getData('/admin/terminal-list-by-filter', {
                    page: 0,
                    size: 10000000, // Keyinchalik yangi API chiqadi
                    status: -1,
                    partnerId: partnerId,
                    merchantId: merchantId
                });
                setTerminals(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setTerminals([]); // PartnerId yo'q bo'lsa, merchantsni tozalash
        }
    };

    useEffect(() => {
        fetchData();
        if (!partners || partners.length === 0) {
            getPartners();
        }
    }, [pagination.current, pagination.pageSize, filters]);

    // PartnerId o'zgarganda merchantsni yangilash uchun alohida useEffect
    useEffect(() => {
        getMerchants();
    }, [filters.partnerId]);

    // PartnerId yoki merchnatid o'zgarganda merchantsni yangilash uchun alohida useEffect
    useEffect(() => {
        getTerminals();
    }, [filters.partnerId, filters.merchantId]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 });
    };

    const handleCreate = async (values) => {
        // await createData('/dashboard', values);
        // fetchData();
        // setIsModalVisible(false);
        // form.resetFields();
    };

    const handleUpdate = async (record) => {
        // await updateData('/dashboard', record.id, record);
        // fetchData();
    };

    const handleDelete = async (id) => {
        // await deleteData('/dashboard', id);
        // fetchData();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Static QRlar</h2>
                {/*<Button type="primary" onClick={showModal}>*/}
                {/*    Static QR qo'shish*/}
                {/*</Button>*/}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, partnerId: value })}
                    size="middle"
                    placeholder="Partner tanlang"
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha partnerlar</Select.Option>
                    {partners?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, merchantId: value })}
                    size="middle"
                    placeholder="Merchant tanlang"
                    disabled={!filters.partnerId} // Partner tanlanmasa disable qilinadi
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha merchantlar</Select.Option>
                    {merchants?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, terminalId: value })}
                    size="middle"
                    placeholder="Terminal tanlang"
                    disabled={!(filters.partnerId && filters.merchantId)} // Partner va merchant tanlanmasa disable qilinadi
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha terminallar</Select.Option>
                    {terminals?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Search
                    placeholder={"Id bo'yicha qidirish"}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="middle"
                    style={{ width: 300 }}
                    onSearch={(val) => handleFilter({ ...filters, search: val })}
                />
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => `Jami: ${total} ta`,
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }} // Gorizontal scroll uchun
            />
            <Modal
                title="Ma'lumot qo'shish"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Nomi"
                        rules={[{ required: true, message: "Iltimos, nomini kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default StaticQrs;